import { render, staticRenderFns } from "./myorder.vue?vue&type=template&id=bc1ef470&scoped=true"
import script from "./myorder.vue?vue&type=script&lang=js"
export * from "./myorder.vue?vue&type=script&lang=js"
import style0 from "./myorder.vue?vue&type=style&index=0&id=bc1ef470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ef470",
  null
  
)

export default component.exports